<template>
  <v-content>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="11" md="10" lg="10" xl="10">
        <v-stepper v-model="etapa" >
          <v-stepper-header>
            <template v-for="e in etapasDaConfiguracao.length">
              <v-stepper-step
                :key="`${e}-step`"
                :complete="etapa > e"
                :step="e"
                edit-icon="$complete"
              >{{etapasDaConfiguracao[e-1]}}</v-stepper-step>

              <v-divider v-if="e !== etapasDaConfiguracao.length" :key="e"></v-divider>
            </template>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content :step="1" class="conteudo-etapa">
              <v-row no-gutters class="div-interna">
                <v-col align-self="center">
                  <ol class="passo-a-passo-etapas body-2">
                    <li>
                      Acesse o
                      <a href="https://console.cloud.google.com/?hl=pt-br" target="_blank" style="text-decoration: none">console do Google Cloud Platform</a> e crie um novo projeto.
                    </li>
                    <li>
                      Pesquise pela API
                      <b>Admin SDK API</b> e ative-a. Faça o mesmo para a API
                      <b>Gmail API</b>.
                    </li>
                    <li>
                      Na parte superior esquerda, clique no ícone com três
                      barrinhas ao lado do logo Google, e selecione a opção
                      <b>IAM e administrador</b>.
                    </li>
                    <li>
                      Selecione a opção
                      <b>Contas de Serviço</b>, a esquerda e clique em
                      <b>Criar Conta de Serviço</b>.
                    </li>
                    <li>
                      Preencha o campos 'Nome da conta de serviço' e
                      automaticamente o campo 'ID da conta de serviço' será
                      preenchido. Depois clique em
                      <b>Criar e Continuar</b>, novamente em <b>Continuar</b>, e
                      por fim em <b>Concluir</b>.
                    </li>
                    <li>
                      Na lista de contas de serviço, clique na conta de serviço
                      criada para edita-la.
                    </li>
                    <li>
                      Clique no botão <b>Chaves</b> e depois em
                      <b>Adicionar chave</b>, caso não possua uma chave,
                      selecione a opção <b>Adioncar chave</b> e escolha a opção
                      P12, caso contrário selecione
                      <b>Fazer upload de uma chave atual</b>. Selecione a chave
                      P12 e clique em <b>Salvar</b>.
                    </li>
                    <li>
                      Selecione a opção <b>Detalhes</b> novamente e copie o ID
                      exclusivo e o e-mail (email da conta de serviço).
                    </li>
                    <li>
                      Clique em <b>Configurações avançadas</b> e depois clique
                      em <b>Configurar</b>
                      para configurar a tela de consentimento OAuth.
                    </li>
                    <li>
                      Para realizar esta configuração, selecione a opção
                      <b>Externo</b> e clique em <b>Criar</b>. Em seguida
                      preencha os campos 'Nome do app', 'E-mail para suporte do
                      usuário' e na seção de
                      <b>Dados de contato do desenvolvedor</b> preenchar o campo
                      'Endereços de e-mail'.
                    </li>
                  </ol>
                </v-col>
                <v-col cols="12" class="text-end" align-self="end">
                  <v-btn color="primary" tile @click="proximaEtapa()">Avançar</v-btn>
                </v-col>
              </v-row>
            </v-stepper-content>
            <v-stepper-content :step="2" class="conteudo-etapa">
              <v-row no-gutters class="div-interna">
                <v-col cols="12">
                  <ol class="passo-a-passo-etapas body-2">
                    <li>
                      Abra o
                      <a href="https://admin.google.com/" target="_blank" style="text-decoration: none">Painel de administração do G Suite</a> e clique no ícone de
                      <b>Segurança</b>.
                    </li>
                    <li>
                      Selecione a opção
                      <b>Controles de API</b> e depois em
                      <b>Gerenciar delegação em todo o domínio</b>.
                    </li>
                    <li>Clique em <b>Adicionar novo</b> e insira o ID exclusivo, anotado ao criar a conta de serviço, no campo <b>ID do cliente</b>.</li>
                    <li>Copie e cole a lista de API's a seguir no campo <b>Escopos OAuth</b> e clique em <b>Autorizar</b></li>
                    <span>https://www.googleapis.com/auth/admin.directory.orgunit,</span>
                    <br />
                    <span>https://www.googleapis.com/auth/admin.directory.orgunit.readonly,</span>
                    <br />
                    <span>https://www.googleapis.com/auth/admin.directory.user,</span>
                    <br />
                    <span>https://www.googleapis.com/auth/admin.directory.user.readonly,</span>
                    <br />
                    <span>https://www.googleapis.com/auth/admin.directory.group.readonly,</span>
                    <br />
                    <span>https://www.googleapis.com/auth/admin.directory.group.member,</span>
                    <br />
                    <span>https://www.googleapis.com/auth/admin.directory.group.member.readonly,</span>
                    <br />
                    <span>https://www.googleapis.com/auth/admin.directory.group,</span>
                    <br />
                    <span>https://www.googleapis.com/auth/gmail.settings.sharing,</span>
                    <br />
                    <span>https://www.googleapis.com/auth/gmail.settings.basic,</span>
                    <br />
                    <span>https://www.googleapis.com/auth/gmail.send</span>
                  </ol>
                </v-col>
                <v-col cols="12" class="text-end" align-self="end">
                  <v-row no-gutters>
                    <v-col class="text-start">
                      <v-btn color="darkGrey" dark tile @click="etapa -= 1">Voltar</v-btn>
                    </v-col>
                    <v-col class="text-end">
                      <v-btn color="primary" tile @click="proximaEtapa()">Avançar</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-stepper-content>
            <v-stepper-content :step="3" class="conteudo-etapa" v-if="alterarConfiguracoes" :loading="loading" >
              <v-row no-gutters v-if="!loading" class="div-interna">
                <v-col cols="12">
                  <ol class="passo-a-passo-etapas body-2">
                    <li>Informe o <b>Email do Administrador G Suite</b>.</li>
                    <li>
                      Informe o
                      <b>Email da Conta de Serviço</b>, anotado ao criar a conta de serviço, no campo com este mesmo nome.
                    </li>
                    <li>
                      Realize o
                      <b>upload da chave P12</b>. Ao final, clique no botão
                      <b>Configurar</b>.
                    </li>
                  </ol>
                </v-col>
                <v-col col="12" class="mt-8">
                  <v-form ref="form" @keydown.native.enter="verificarRequisicaoParaConfiguracao()">
                    <v-row dense justify="center" align="center">
                      <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                        <v-text-field id="emailGSuite" validate-on-blur v-model="configuracoes.emailAdmGSuite" label="Email do administrador G Suite" :rules="[rules.campoObrigatorio, rules.email]"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                        <v-text-field
                          v-model="configuracoes.contaServico"
                          :rules="[rules.campoObrigatorio, rules.email, rules.contaDeServico]"
                          label="E-mail conta de serviço"
                          hint="Exemplo: seuemail@assinaturaapp.gserviceaccount.com"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                        <v-file-input
                          accept=".P12"
                          v-model="chaveP12"
                          :rules="[rules.chaveP12]"
                          label="Chave P12"
                        ></v-file-input>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
                <v-col cols="12" class="mt-12" align-self="end">
                  <v-row no-gutters>
                    <v-col class="text-start">
                      <v-btn color="darkGrey" dark tile @click="etapa -= 1">Voltar</v-btn>
                    </v-col>
                    <v-col class="text-start" v-if="verCancelarAlteracaoDaConfiguracao">
                      <v-btn color="accent" dark tile @click="() => {
                        $router.go(-1);
                        verCancelarAlteracaoDaConfiguracao = false;
                      }">CANCELAR</v-btn>
                    </v-col>
                    <v-col class="text-end" cols="3" xl="9" lg="9" md="9" sm="8">
                      <v-btn
                        tile
                        color="primary"
                        @click="verificarRequisicaoParaConfiguracao()"
                        :disabled="idDoCliente == null"
                      >Salvar</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row v-else justify="center" class="fill-height text-center">
                <v-col align-self="center" cols="12">
                  <v-progress-circular class="mt-4" indeterminate color="secondary" :size="174" :width="6"></v-progress-circular>
                </v-col>
              </v-row>
            </v-stepper-content>
            <v-stepper-content :step="3" class="conteudo-etapa" v-else>
              <v-row no-gutters class="text-center div-interna">
                <v-col cols="12" class="text-break mb-3">
                  <h1 class="align-middle" style="color: #4caf50">Configuração realizada com sucesso</h1>
                </v-col>
                <v-col cols="12">
                  <v-row class="mt-6">
                    <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                      <v-text-field v-model="configuracoes.emailAdmGSuite" label="Email do administrador G Suite" readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                      <v-text-field
                        v-model="configuracoes.contaServico"
                        label="E-mail conta de serviço"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                      <v-text-field v-model="urlChaveP12" label="Chave P12" readonly></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="text-end mt-10" align-self="end">
                  <v-btn
                    tile
                    color="primary"
                    @click="() => {
                        alterarConfiguracoes = true;
                        configuracoes.contaServico = '';
                        configuracoes.emailAdmGSuite = '';
                        verCancelarAlteracaoDaConfiguracao = true;
                      } "
                  >Alterar</v-btn>
                </v-col>
              </v-row>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-content>
</template>

<script>
import { enviar, receber, editar } from "../mixins/RequisicaoMixin.js";
import {
  headersPadrao,
  headersUploadDeArquivo
} from "../mixins/HeadersMixin.js";

export default {
  data() {
    return {
      configuracoes: {
        id: null,
        emailAdmGSuite: "",
        contaServico: ""
      },
      chaveP12: {},
      urlChaveP12: "",
      alterarConfiguracoes: false,
      verCancelarAlteracaoDaConfiguracao: false,
      rules: {
        campoObrigatorio: value => !!value || "Campo obrigatório",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Digite um e-mail válido";
        },
        chaveP12: value =>
          (value != undefined && value.name != undefined) ||
          "Insira a chave P12",
        contaDeServico: value => value.indexOf("gserviceaccount.com") != -1 ? true : "O e-mail deve conter 'gserviceaccount.com'"
      },
      loading: false,
      etapa: 1,
      etapasDaConfiguracao: [
        "Gerar Credências",
        "Liberar Acesso",
        "Configurar Integração"
      ],
      idDoCliente: null
    };
  },
  methods: {
    verificarRequisicaoParaConfiguracao() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store.commit("carregando", "Validando autorização e autenticação no G Suite.");
        if (this.configuracoes.id != null) {
          this.atualizarConfiguracoes();
        } else {
          this.salvarConfiguracoes()
        }
      }
    },
    async salvarConfiguracoes(){
      await enviar(
        `api/v1/clientes/${this.idDoCliente}/configuracoes`,
        headersPadrao(),
        this.configuracoes
      )
        .then(resposta => {
          this.configuracoes.id = resposta;
          this.salvarChaveP12();
        })
        .catch(erro => {
          if(erro.request.status == 404){
            this.$store.commit("atualizarMensagemDeErro", JSON.parse(erro.request.response).debugMessage)
            this.$store.commit("erro");
          } else this.$store.commit("erro", "Erro ao salvar configurações.")
          this.loading = false;
        });
    },
    async salvarChaveP12() {
      let chaveP12Form = new FormData();
      chaveP12Form.append("arquivo", this.chaveP12);
      await enviar(
        `api/v1/clientes/${this.idDoCliente}/configuracoes/${this.configuracoes.id}`,
        headersUploadDeArquivo(),
        chaveP12Form
      )
        .then(resposta => {
          console.log(resposta);
          this.loading = false;
          this.$store.commit("sucesso", "Configurações salvas com sucesso.");
          this.$router.go(-1);
        })
        .catch(erro => {
          if(erro.request.status == 400){
            this.$store.commit("atualizarMensagemDeErro", JSON.parse(erro.request.response).debugMessage)
            this.$store.commit("erro");
          } else this.$store.commit("erro", "Erro ao validar credenciais de acesso.")
          this.loading = false;
        });
    },
    async buscarConfiguracoes() {
      await receber(
        `api/v1/clientes/${this.idDoCliente}/configuracoes`,
        headersPadrao()
      )
        .then(resposta => {
          console.log(resposta);
          this.configuracoes.contaServico = resposta.contaServico;
          this.configuracoes.id = resposta.id;
          this.configuracoes.emailAdmGSuite = resposta.emailAdmGSuite
          this.urlChaveP12 = `https://storage.googleapis.com/${resposta.urlChave}`;
        })
        .catch(erro => erro.request.status != 404 ? this.$store.commit("erro", "Erro ao buscar configurações.") : "");
    },
    async atualizarConfiguracoes() {
      await editar(
        `api/v1/clientes/${this.idDoCliente}/configuracoes/${this.configuracoes.id}`,
        headersPadrao(),
        this.configuracoes
      )
        .then(resposta => {
          console.log(resposta);
          this.salvarChaveP12();
        })
        .catch(erro => {
          if(erro.request.status == 404) {
            this.$store.commit("atualizarMensagemDeErro", JSON.parse(erro.request.response).debugMessage)
            this.$store.commit("erro");
          } else this.$store.commit("erro", "Erro ao salvar configurações.")
          this.loading = false;
        });
    },
    pegarIdDoCliente(){
      if(this.$route.query.id != undefined) this.idDoCliente = this.$route.query.id
      else {
        this.idDoCliente = JSON.parse(localStorage.getItem("usuarioLogado")).cliente
      }
    },
    proximaEtapa(){
      this.etapa += 1
      if(this.etapa != 2) {
        setTimeout(()=> {
          document.getElementById("emailGSuite").focus();
        }, 50)
      }
    }
  },
  async created() {
    this.pegarIdDoCliente();
    await this.buscarConfiguracoes();
    if (this.configuracoes.id == undefined) this.alterarConfiguracoes = true;
    else {
      this.alterarConfiguracoes = false;
      this.etapa = 3;
    }
  }
};
</script>

<style scoped>
.etapas-configuracao {
  color: #4c2779;
  font-weight: bold;
}
.passo-a-passo-etapas {
  color: black;
  font-weight: 400;
}
a {
  color: blue !important;
}
.conteudo-etapa {
  height: 380px;
}
.div-interna {
 height: 345px;
}
</style>